<div class="performance-by-time-container">
  <ng-container *ngIf="data?.brands?.length">
    <div class="table-wrapper">
        <div class="data-row" *ngFor="let brand of data?.brands">
            <div class="y-label-container" [matTooltip]="brand.brandName">
                <div class="y-label label">{{ brand.brandName }}</div>
                <div class="y-line"></div>
            </div>
            <div class="cells-container">
                <div
                    class="cell"
                    *ngFor="let item of brandValueColorMap[brand.brandKey]; let i = index"
                    [tp]="tooltipTemplate" [tpPlacement]="'bottom'" [tpClassName]="'custom-tooltip'" [tpDuration]="1"
                    [style.background-color]="item.color">

                    <ng-template #tooltipTemplate>
                        <ng-container *ngIf="getTooltipForValue(item.value, brand, i) as item">
                            <div class="tooltip-card">
                                <div class="header">{{ item.hour }}</div>
                                <div class="tooltip-item">
                                    <div class="brand-info">
                                        <div class="color-dot" [style.backgroundColor]="item.brandColor"></div>
                                        <span class="brand-name">{{ item.brandName }}</span>
                                    </div>
                                    <div class="value">{{ item.value }}</div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-template>
                </div>
            </div>
        </div>
        <div class="hours-row">
            <div class="y-label-container empty"></div>
            <div class="hours-container">
                <div class="x-label-container" *ngFor="let hour of [].constructor(24); let i = index">
                    <div class="x-line"></div>
                    <div class="x-label label"> {{ i | hourTwoDigits }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="scale-wrapper">
        <div class="scale-container">
            <div class="scale">
                <div *ngFor="let color of colors" class="scale-block" [style.background-color]="color"></div>
            </div>
            <div class="labels">
                <span class="label" *ngFor="let step of steps">{{ step }}</span>
            </div>
        </div>
        <div class="no-data">
            <div class="scale-block" [style.background-color]="noDataColor"></div>
            <span class="label">No Data</span>
        </div>
    </div>
  </ng-container>
</div>
<app-loader *ngIf="loading"></app-loader>
<app-no-widget-data
  *ngIf="!data?.brands?.length && !loading"
  [svgSrc]="!data?.isUnderDateThreshold
    ? 'svg/no-widget-data-filters-apply-different.svg'
    : 'svg/no-widget-data-date-threshold.svg'">
</app-no-widget-data>
